module.exports = __webpack_public_path__ + "static/media/promo-willy.97a5eedc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-willy.jpg
// module id = 324
// module chunks = 0